import { API as api } from "./api";

export const getSettingsOptions = async () => {
  const res = await api.get("/settings/options");
  const d = res?.data;
  // Normalize createResponse shape { statusCode, body: { message, data } }
  if (d && d.body && typeof d.body === "object") return d.body.data || {};
  // Or plain JSON object
  if (d && d.data && typeof d.data === "object" && !d.body) return d.data;
  return d || {};
};

export default { getSettingsOptions };
